import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { EntityProps, EntityState, setAllEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

import { Région } from '../model/région.model';
import { RégionService } from '../région.service';
import { v7 as uuidv7 } from 'uuid';
import { ToastrErrorComponent } from '@shared/components/toastr/toastr-error.component';
import { toast } from 'ngx-sonner';

export function avecMéthodesRégions<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Région>>(),
      props: type<EntityProps<Région>>(),
    },
    withMethods((store) => ({
      chargerRégions: (state: { régions: Région[] }) => patchState(store, setAllEntities(state.régions)),
    })),
    withMethods((store, service = inject(RégionService)) => ({
      charger: rxMethod<string>(
        pipe(
          switchMap((idCartographie) =>
            service.trouverTous(idCartographie).pipe(
              tapResponse({
                next: (response) => {
                  store.chargerRégions({ régions: response.items });
                },
                error: (err) => {
                  const toastrId = uuidv7();
                  toast.custom(ToastrErrorComponent, {
                    componentProps: {
                      message: `Un problème est survenu lors du chargement des régions, contactez le support.`,
                      id: toastrId,
                    },
                    id: toastrId,
                  });
                  console.error('Error lors du chargement des régions via le Store: ', err);
                },
              }),
            ),
          ),
        ),
      ),
    })),
  );
}
